﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.describe = exports.getParentChain = exports.disposeNode = exports.addDisposableEventListener = void 0;
const DataStructures_1 = require("./DataStructures");
const _eventListenerCollection = new WeakMap();
/**
 * To be used with disposeNode function.
 * @param element Target DOM Node.
 * @param type Event name.
 * @param listener Listener callback function.
 * @param options Event options.
 */
const addDisposableEventListener = (element, type, listener, options) => {
    element.addEventListener(type, listener, options);
    const listeners = _eventListenerCollection.get(element);
    if (listeners) {
        listeners.add([type, listener]);
    }
    else {
        _eventListenerCollection.set(element, new Set([[type, listener]]));
    }
};
exports.addDisposableEventListener = addDisposableEventListener;
/**
 * Remove all event listeners from a Element to delete it savely.
 *
 * The Event listeners have to be added using addDisposableEventListener function.
 * @param element Target DOM Node.
 * @param removeElementFromDOM Whether the remove method should be called after the dispose, true is default.
 */
const disposeNode = (element, removeElementFromDOM = true) => {
    const checkAndClean = (el) => {
        const track = _eventListenerCollection.get(el);
        if (track) {
            track.forEach((data) => {
                el.removeEventListener(...data);
            });
        }
    };
    checkAndClean(element);
    element.querySelectorAll("*").forEach((el) => {
        checkAndClean(el);
    });
    if (removeElementFromDOM && "remove" in element) {
        element.remove();
    }
};
exports.disposeNode = disposeNode;
/**
 * Gets the whole parental chain of a DOM node (excluding the node itself).
 */
const getParentChain = (el) => {
    const chain = new Array();
    let parent = el.parentNode;
    while (parent) {
        chain.push(parent);
        parent = parent.parentNode;
    }
    return chain;
};
exports.getParentChain = getParentChain;
const describe = (el) => {
    const description = new DataStructures_1.StringBuilder(`<${el.tagName}`);
    if (el.id) {
        description.append(` id="${el.id}"`);
    }
    if (el.classList.length > 0) {
        description.append(' class="');
        description.append(Array.from(el.classList).join(" "));
        description.append('"');
    }
    if (el.attributes.length > 0) {
        for (const attr of el.attributes) {
            if (attr.value) {
                description.append(` ${attr.name}="${attr.value}"`);
            }
            else {
                description.append(` ${attr.name}`);
            }
        }
    }
    description.append(">");
    return description.toString();
};
exports.describe = describe;
